import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeedbackRoutingModule } from './feedback-routing.module';
import { FeedbackComponent } from './feedback/feedback.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { MatButtonModule } from '@angular/material';

import { FeedbackProvider } from './feedbackProvider'
@NgModule({
  imports: [
    CommonModule,
    FeedbackRoutingModule,
    FormsModule, ReactiveFormsModule,
    MatButtonModule
  ],
  declarations: [FeedbackComponent],
  exports: [FeedbackComponent],
  providers: [FeedbackProvider]
})
export class FeedbackModule { }
